import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { logError } from '@/helpers/log-helper';
import categoryQuery from '~/graphql/category.gql';
import { extractCategoryHash, buildCategoryProductsQuery } from '~/helpers/extract-helper';
import activateOpenFacets from '~/const/openFacet';

function fetchCategory(_x, _x2, _x3) {
  return _fetchCategory.apply(this, arguments);
}

function _fetchCategory() {
  _fetchCategory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context, alias, query) {
    var profileId,
        hash,
        locale,
        _buildCategoryProduct,
        offset,
        limit,
        sortBy,
        orderBy,
        filterBy,
        requestWithOpenFacet,
        response,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            profileId = _args.length > 3 && _args[3] !== undefined ? _args[3] : null;
            hash = extractCategoryHash(alias);
            locale = context.state.i18n.currentLocale.iso;
            _buildCategoryProduct = buildCategoryProductsQuery(query), offset = _buildCategoryProduct.offset, limit = _buildCategoryProduct.limit, sortBy = _buildCategoryProduct.sortBy, orderBy = _buildCategoryProduct.orderBy, filterBy = _buildCategoryProduct.filterBy;
            _context.prev = 4;
            requestWithOpenFacet = activateOpenFacets(context.$cookies) && (process.client || context.state.searchEngine.isSearchEngine);
            _context.next = 8;
            return context.app.apolloProvider.defaultClient.query({
              query: categoryQuery,
              variables: {
                profileId: profileId,
                variantImageTransformation: process.client && context.$cookies.get('smart-crop-variants') ? 'g_auto,c_crop,r_max' : '',
                locale: locale,
                hash: hash,
                offset: offset,
                limit: limit,
                sortBy: sortBy,
                orderBy: orderBy,
                filterBy: filterBy,
                allowSeoOpenFacets: requestWithOpenFacet
              }
            });

          case 8:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](4);
            logError({
              msg: _context.t0,
              context: context
            });
            return _context.abrupt("return", null);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 12]]);
  }));
  return _fetchCategory.apply(this, arguments);
}

export { fetchCategory as default };